<template>
  <div class="absolute">
    {{ formattedTime }}
  </div>
</template>

<script>
export default {
  name: 'Timer',
  props: {
    seconds: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      currentTime: this.seconds,
      intervalId: null,
      isRunning: false,
    };
  },

  computed: {
    formattedTime() {
      const hours = Math.floor(this.currentTime / 3600);
      const minutes = Math.floor((this.currentTime % 3600) / 60);
      const seconds = this.currentTime % 60;

      if (hours > 0) {
        return `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },

  mounted() {
    this.start();
  },

  beforeUnmount() {
    this.stop();
  },

  watch: {
    seconds(newValue) {
      if (!this.isRunning) {
        this.currentTime = newValue;
      }
    },
  },

  methods: {
    start() {
      if (!this.isRunning) {
        this.isRunning = true;
        this.intervalId = setInterval(() => {
          if (this.currentTime > 0) {
            this.currentTime -= 1;
          } else {
            this.stop();
            this.$emit('finished');
          }
        }, 1000);
      }
    },
    stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.isRunning = false;
      }
    },
    reset() {
      this.stop();
      this.currentTime = this.seconds;
    },
    toggle() {
      if (this.isRunning) {
        this.stop();
      } else {
        this.start();
      }
    },
  },
};
</script>

<style scoped></style>
